/*
    mixins/watchActivityTimes.js

    Each time an Activity calls getTimes, 
    OR when a user modifies the activy.Times array by interacting with the UI, 
    there are few things that need to happen:

    1.  hideUnselectedTimes needs to be calculated

    2.  activity.SelectedTimes needs to be calcualted

    3.  if CapacityTypeKey == 2, it acts like large group mode for the most part, 
        but we need to deselect the other times so that only one time is selected

    This mixin is used in:

    1.  individual/Details.vue
    2.  PackageActivityCard.vue

*/

export default {
	watch: {
		'activity.Times': {
			handler() {
				//
				//console.log("watch activity.Times at mixins/watchActivityTimes.js");

				//alert("watch activity.Times for activity ");
				this.hideUnselectedTimes = false;

				if (this.activity && this.activity.Times) {
					//console.log("activity.Times.length: ", this.activity.Times);
					if (
						this.activeProductDetails &&
						(this.activeProductDetails.IsLargeGroup ||
							this.activity.CapacityTypeKey == 2 ||
							this.activity.CapacityTypeKey == 3) &&
						this.activeProductDetails.Activities
					) {
						// SelectedTimes should only contain Times that are actually Selected
						console.warn(
							'SelectedTimes should only contain Times that are actually Selected'
						);

						this.activity.SelectedTimes = this.activity.Times.filter((ti) => {
							return ti.IsSelected === true;
						});

						// clean up Selected times when CapacityTypeKey is 2
						// so that only one time is selected
						//alert("like large group mode");
						if (
							(this.activity.CapacityTypeKey == 2 ||
								this.activity.CapacityTypeKey == 3) &&
							this.$route.params.timeId &&
							this.activity.SelectedTimes
						) {
							//alert("watch activity.Times CapacityTypeKey");
							this.activity.SelectedTimes.forEach((ti) => {
								if (ti.Value * 1 === this.$route.params.timeId * 1) {
									//alert("I'm a keeper- " + ti.Value);
									//ti.Rates.forEach(rate => {
									//console.log("rate.Participants: " + rate.Participants);
									//});
								}
								//
								else {
									//alert("Not a keeper------------------" + ti.Value);
									ti.Rates.forEach((rate) => {
										rate.Participants = 0;
									});
								}
							});
						}
					} //

					// not Large Group Mode && not CapacityTypeKey == 2
					else if (this.activeProductDetails.Activities) {
						// this should cover the cases where IsPrivateTour is true
						// and for simple time selection mode
						//alert("not large group");
						let findSelectedTimes = this.activity.Times.filter((time) => {
							return time.IsSelected === true;
						});

						if (findSelectedTimes.length) {
							//findSelectedTimes.forEach(stime => {
							// when getTimes returns Times[] I am copying the activities[].Rates
							// not sure I need to do this.....?
							//stime.Rates = this.activity.Rates;
							//});

							//this.activity.SelectedTimes = findSelectedTimes;
							this.$set(this.activity, 'SelectedTimes', findSelectedTimes);

							//alert("not Large Group Mode && not CapacityTypeKey == 2 ");
						}
					}
				} else {
					// console.log(
					//   "No this.activity.Times. this.activity.SelectedTime not modified."
					// );
				}
				//

				//
				/*
                  else {
                    //alert("watch activity.Times NOT CapacityTypeKey == 2 - SIMPLE times");
                    this.activity.SelectedTimes = [];
        
                    var findSelectedTimes = this.activity.Times.filter(ti => {
                      return ti.IsSelected == true;
                    });
        
                    if (findSelectedTimes) {
                      findSelectedTimes.forEach(st => {
                        st.Rates = this.activity.Rates;
                      });
        
                      this.activity.SelectedTimes = findSelectedTimes;
                    }
                  }
                  */

				// if there is a selected time
				// we can hide the other times
				if (
					this.activity &&
					this.activity.SelectedTimes &&
					this.activity.SelectedTimes.length
				) {
					//

					this.activity.SelectedTimes.forEach((st) => {
						//console.log("for large group or rate duration");
						let findPopulatedRates = st.Rates.find((r) => {
							return r.Participants > 0;
						});

						if (
							findPopulatedRates &&
							(this.activity.CapacityTypeKey == 2 ||
								this.activity.CapacityTypeKey == 3)
						) {
							//
							this.hideUnselectedTimes = true;
							//alert("has Selected Times 1 CapacityTypeKey == 2");
						}
						// for simple times
						else if (
							st.IsSelected &&
							this.activity.CapacityTypeKey != 2 &&
							!this.activeProductDetails.IsLargeGroup
						) {
							this.hideUnselectedTimes = true;
							//alert("has Selected Times 2 SimpleTime");
						}
						if (this.activeProductDetails.IsLargeGroup) {
							this.hideUnselectedTimes = false;
							//alert("has Selected Times 3 IsLargeGroup");
						}
					});
				}

				if (typeof window.OnTimeSelected != 'undefined') {
					//console.log("window.OnTimeSelected()");
					window.OnTimeSelected(this.$store.getters.simpleOrder, this.activity);
				}
			},
			deep: true,
			immediate: true,
		},
	},
};
